$(function () {
    var favourites_button = $('.buttonFavourites');
    var favourites_button_text = favourites_button.find('span');

    favourites_button.click(function (event) {
        event.preventDefault();
        if ($(this).hasClass('__favourited')) {
            $(this).removeClass('__favourited');
            $(this).find(favourites_button_text).html('Add to favourites');
        }
        else {
            $(this).addClass('__favourited');
            $(this).find(favourites_button_text).html('Remove from favourites');
        }
    });
});